const actions = {
  GET_RECHARGE_PLAN_WISE_MAPPING: "GET_RECHARGE_PLAN_WISE_MAPPING",
  GET_RECHARGE_PLAN_WISE_MAPPING_SUCCESS: "GET_RECHARGE_PLAN_WISE_MAPPING_SUCCESS",
  GET_RECHARGE_PLAN_WISE_MAPPING_FAILED: "GET_RECHARGE_PLAN_WISE_MAPPING_FAILED",
  GET_ALL_RECHARGE_PRICE_MAPPING_DATA: "GET_ALL_RECHARGE_PRICE_MAPPING_DATA",
  GET_ALL_RECHARGE_PRICE_MAPPING_DATA_SUCCESS:
    "GET_ALL_RECHARGE_PRICE_MAPPING_DATA_SUCCESS",
  GET_ALL_RECHARGE_PRICE_MAPPING_DATA_FAILED:
    "GET_ALL_RECHARGE_PRICE_MAPPING_DATA_FAILED",
  // ADD and Update
  UPDATE_RECHARGE_PRICE_MAPPING_DATA: "UPDATE_RECHARGE_PRICE_MAPPING_DATA",
  UPDATE_RECHARGE_PRICE_MAPPING_DATA_SUCCESS:
    "UPDATE_RECHARGE_PRICE_MAPPING_DATA_SUCCESS",
  UPDATE_RECHARGE_PRICE_MAPPING_DATA_FAILED:
    "UPDATE_RECHARGE_PRICE_MAPPING_DATA_FAILED",

  OPEN_UPDATE_RECHARGE_PORTIN_MODAL: "OPEN_UPDATE_RECHARGE_PORTIN_MODAL",
  CLOSE_UPDATE_RECHARGE_PORTIN_MODAL: "CLOSE_UPDATE_RECHARGE_PORTIN_MODAL",

  RESET_RECHARGE_PRICE_MAPPING_MESSAGES:
    "RESET_RECHARGE_PRICE_MAPPING_MESSAGES",

  getAllRechargePriceMappingData: (data) => ({
    type: actions.GET_ALL_RECHARGE_PRICE_MAPPING_DATA,
    payload: { data },
  }),
  getAllRechargePriceMappingDataSuccess: (data) => ({
    type: actions.GET_ALL_RECHARGE_PRICE_MAPPING_DATA_SUCCESS,
    payload: { data },
  }),
  getAllRechargePriceMappingDataFailed: (error) => ({
    type: actions.GET_ALL_RECHARGE_PRICE_MAPPING_DATA_FAILED,
    payload: { error },
  }),

  getRechargePlanWiseMapping: (data) => ({
    type: actions.GET_RECHARGE_PLAN_WISE_MAPPING,
    payload: { data },
  }),
  getRechargePlanWiseMappingSuccess: (data) => ({
    type: actions.GET_RECHARGE_PLAN_WISE_MAPPING_SUCCESS,
    payload: { data },
  }),
  getRechargePlanWiseMappingFailed: (error) => ({
    type: actions.GET_RECHARGE_PLAN_WISE_MAPPING_FAILED,
    payload: { error },
  }),

  updateRechargePriceMappingData: (data, searchData) => ({
    type: actions.UPDATE_RECHARGE_PRICE_MAPPING_DATA,
    data,
    searchData,
  }),
  updateRechargePriceMappingDataSuccess: (message, data) => ({
    type: actions.UPDATE_RECHARGE_PRICE_MAPPING_DATA_SUCCESS,
    message,
    data,
  }),
  updateRechargePriceMappingDataFailed: (error) => ({
    type: actions.UPDATE_RECHARGE_PRICE_MAPPING_DATA_FAILED,
    error,
  }),
  openUpdateRechargePortinModal: () => ({
    type: actions.OPEN_UPDATE_RECHARGE_PORTIN_MODAL,
  }),

  closeUpdateRechargePortinModal: () => ({
    type: actions.CLOSE_UPDATE_RECHARGE_PORTIN_MODAL,
  }),
  resetRechargePriceMappingMessages: () => ({
    type: actions.RESET_RECHARGE_PRICE_MAPPING_MESSAGES,
  }),
};
export default actions;
